// tslint:disable
import React, { useState, useEffect, useContext } from 'react';
import { IRootState } from 'src/reducers';
import { useDispatch, useSelector } from 'react-redux';
import { useFetch } from 'use-http';
import _ from 'lodash';
import { Url } from 'src/api';
import TownshipCard from './TownshipCard';
import CardContainer from 'src/components/common/CardContainer.redesign';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { DialogContext, dialogCreators } from 'src/providers/DialogProvider';
import { push } from 'connected-react-router';
import { LandSystem } from 'src/models/LandSystem';
import { ODataOptions, ODataFilter, ODataFilterOperators, ODataOrderByDirection } from 'src/util/ODataBuilder';
import SearchListData from 'src/models/SearchListData';
import ConfirmDeletionDialog from '../dialogs/ConfirmDeletionDialog';
import actions from 'src/actions';
import DialogList from 'src/dialogs';
import FilterWithDropdowns from 'src/components/common/Filter.redesign';

interface ITownshipListProps {
    setTractListId: (tractListId: number) => void;
    landSystem: LandSystem;
    searchFilterData?: SearchListData[];
    filterTownships?: boolean;
    refreshTags?: () => void;
}

const TownshipList: React.FC<ITownshipListProps> = (props) => {
    const appContext = useSelector((state: IRootState) => state.appContext);
    const { get, put, response } = useFetch();
    const [dataLoaded, setDataLoaded] = useState(false);
    const [sectionSearchTerm, setSectionSearchTerm] = useState('');
    const [filterTownships, setFilterTownships] = useState(false);
    const [townshipIds, setTownshipIds] = useState<number[]>([]);
    const [selectedTownship, setSelectedTownship] = useState(undefined);
    const [selectedSection, setSelectedSection] = useState(undefined);
    const dialogContext = useContext<dialogCreators>(DialogContext);
    const [filterDataOptions, setFilterDataOptions] = useState<ODataOptions>(new ODataOptions);
    const [searchFilterData, setSearchFilterData] = useState<Array<SearchListData>>([]);
    const dispatch = useDispatch();

    const getFilteredTownshipIds = async () => {
        const filteredTownshipIds = await get(`${Url.project.getTownships(appContext)}/tags/${filterDataOptions.toString()}`);

        if (response.ok) {
            setTownshipIds(filteredTownshipIds);
        }
    }

    useEffect(() => {
        let newDataOptions = _.cloneDeep(filterDataOptions);
        let hadFilters = newDataOptions.hasFilters();
        newDataOptions?.clearFilters('KUDUTags');
        if (filterTownships === true) {
            for ( let tagListIndex = 0; tagListIndex < searchFilterData?.length; tagListIndex++) {
                if (searchFilterData[tagListIndex].state === true) {
                    newDataOptions?.addFilter(new ODataFilter('KUDUTags', ODataFilterOperators.Equals, searchFilterData[tagListIndex].tag.name));
                }
            }
            if (newDataOptions.hasFilters() || hadFilters) {
                setFilterDataOptions(newDataOptions);
            }
        }
    }, [searchFilterData]);

    const loadInitialData = async () => {
        const data = await get(`${Url.project.getAreas(appContext)}?select=id`);
        let townshipIdForSection: number = undefined;

        let dataOptions = new ODataOptions();
        dataOptions.addOrderBy('TownshipNumber', ODataOrderByDirection.Ascending);
        setFilterDataOptions(dataOptions);

        if (appContext.sectionNumber) {
            const township = await get(`${Url.project.getSection(appContext, appContext.sectionNumber)}/township`);
            townshipIdForSection = township;
        }

        if (response.ok) {
            setTownshipIds(data);
            if (townshipIdForSection) {
                setSelectedTownship(data[(data as number[]).indexOf(townshipIdForSection)]);
            } else {
                setSelectedTownship(undefined);
            }
            setDataLoaded(true);
        }
    };

    const findSections_Tracts = () => {
        let section = '';
        let tract = '';
        if (sectionSearchTerm.search('.') > -1) {
            const searchTokens = sectionSearchTerm.split('.');
            section = searchTokens?.length > 0 ? searchTokens[0] : '0';
            tract = searchTokens?.length > 1 ? searchTokens[1] : '0';
            if (searchTokens?.length > 0) {
                findSection();
            }
        }
        
        let urlSuffix = '';
        if (tract !== '0') {
            urlSuffix = `/tracts/${tract}/horizons/1`;
            dispatch(push(`/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/sections/${section}` + urlSuffix));
        }
    }

    const onTownshipSelected = (townshipId: number) => {
        dispatch(push(`/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/tracts`));
        setSelectedTownship(townshipId);
    };

    const reloadTownships = async (townshipId: number) => {
        setDataLoaded(false);
        setTownshipIds([]);
        await loadInitialData();
        setSelectedTownship(townshipId);
        props.refreshTags();
    };

    const findSection = async () => {
        let sectionNumber: number | string = 0;
        if (!isNaN(Number(sectionSearchTerm))) {
            sectionNumber = Number(sectionSearchTerm);
        }
        const townshipNumber = await get(`${Url.project.getSection(appContext, sectionNumber)}/township`);
        if (response.ok) {            
            setSelectedSection(sectionNumber);
            setSelectedTownship(townshipNumber);
        }
    };

    useEffect(() => {
        loadInitialData();
    }, []);

    useEffect(() => {
        if (filterDataOptions?.hasFilters() || filterDataOptions?.getOrderByProperty() === "TownshipNumber") {
            getFilteredTownshipIds();
        }
    }, [filterDataOptions]);

    useEffect(() => {
        if (props?.searchFilterData?.length > 0) {
            setSearchFilterData(props.searchFilterData);
        }
    }, [props.searchFilterData]);

    useEffect(() => {
        setFilterTownships(props.filterTownships);
        if (props.filterTownships !== undefined) {
            let newDataOptions = _.cloneDeep(filterDataOptions);
            newDataOptions?.clearFilters('KUDUTags');
            if (props.filterTownships === true) {
                for ( let tagListIndex = 0; tagListIndex < searchFilterData?.length; tagListIndex++) {
                    if (searchFilterData[tagListIndex].state === true) {
                        newDataOptions?.addFilter(new ODataFilter('KUDUTags', ODataFilterOperators.Equals, searchFilterData[tagListIndex].tag.name));
                    }
                }
            }
            setFilterDataOptions(newDataOptions);
        }
    }, [props.filterTownships]);

    const toggleDeleteConfirmation = async () => {
        let township = await get(`${Url.project.getTownship(appContext, selectedTownship)}`);
        console.log('township: ', township);

        if (township && township.sectionCount <= 0) {
            dispatch(actions.layout.showDialog(DialogList.CONFIRM_DELETE));
        } else {
            window.alert('Cannot delete a township that still has sections attached');
        }
    };

    const hideDialog = () => {
        dispatch(actions.layout.hideDialog());
    };

    const deleteTownship = async () => {
        hideDialog();
        await put(`${Url.project.deleteTownship(appContext, selectedTownship)}`);

        if (response.ok) {
            loadInitialData();
        } else {
            window.alert('Error deleting township: ' + response);
        }
    };

    const updateTownshipFilter = (options: ODataOptions) => {
        let newDataOptions = _.cloneDeep(options);
        if (filterTownships === true) {
            for (let i = 0; i < searchFilterData?.length; i++) {
                if (searchFilterData[i].state === true) {
                    newDataOptions?.addFilter(new ODataFilter('KUDUTags', ODataFilterOperators.Equals, searchFilterData[i].tag.name));
                }
            }
        }
        if (newDataOptions.getOrderByProperty() === undefined) {
            newDataOptions.addOrderBy('TownshipNumber', ODataOrderByDirection.Ascending);
        }
        setFilterDataOptions(newDataOptions);
    };

    if (!dataLoaded) {
        return <div>Loading...</div>;
    } else {
        return (
            <>
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '1rem', background: '#ddd', padding: '.8rem' }}>
                    <div style={{ height: '100%', verticalAlign: 'center', fontWeight: 'bold', fontSize: '1.3em' }}>Townships</div>
                    <div>
                        <input
                            size={16}
                            type="text"
                            name={`sectionSearch`}
                            id={`section-tract-search`}
                            hidden={false}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                setSectionSearchTerm(e.target.value)
                            }
                            onClick={() => (document.getElementById('section-tract-search') as HTMLInputElement).value === `[Section/Map #].[Tract #]` ?
                            (document.getElementById('section-tract-search') as HTMLInputElement).value = '' : false}
                            maxLength={15}
                            defaultValue={`[Section/Map #].[Tract #]`}
                        />
                        <Button
                            size="small"
                            intent="primary"
                            text="Find Tracts"
                            onClick={() =>
                                findSections_Tracts()
                            }
                        />
                    </div>
                    <div>
                        <Button
                            size="small"
                            intent="primary"
                            text="Create Township"
                            onClick={() =>
                                dialogContext.project.addUpdateDeleteTownship(0, 'create', props.landSystem, async (townshipId: number) => {
                                    props.setTractListId(undefined);
                                    await reloadTownships(townshipId);
                                    setSelectedTownship(townshipId);
                                })
                            }
                        />
                    </div>
                </div>
                <FilterWithDropdowns
                    sortItems={[
                        { group: 1, text: 'Township Number (Asc)', icon: 'numeric-up', orderName: 'TownshipNumber', orderDirection: 'ascending' },
                        { group: 1, text: 'Township Number (Desc)', icon: 'numeric-down', orderName: 'TownshipNumber', orderDirection: 'descending' },
                    ]}
                    filterItems={[
                        { group: 1, text: 'Township Name', orderName: 'TownshipName', orderDirection: 'ascending', type: 'number' },
                        { group: 1, text: 'Section Number', orderName: 'SectionNumber', orderDirection: 'ascending', type: 'number' },
                    ]}
                    onFilterChanged={updateTownshipFilter}
                />
                {townshipIds?.length > 0 && (
                    <CardContainer>
                        {townshipIds.map((id) => (
                            <TownshipCard
                                key={id}
                                townshipId={id}
                                isActive={selectedTownship === id}
                                onTownshipSelected={onTownshipSelected}
                                onSectionSelected={props.setTractListId}
                                parentSelectedSection={selectedSection}
                                reloadTownships={reloadTownships}
                                landSystem={props.landSystem}
                                toggleDelete={toggleDeleteConfirmation}
                            />
                        ))}
                    </CardContainer>
                )}
                {townshipIds?.length === 0 && (
                    <div style={{ padding: '2rem', border: '2px red solid', margin: '1rem', textAlign: 'center', fontWeight: 'bold', fontSize: '1.1em' }}>
                        No Townships Found.
                    </div>
                )}
                <ConfirmDeletionDialog
                    body={`Are you sure you want to delete this township?`}
                    confirmAction={deleteTownship}
                    hideDialog={hideDialog}
                    dialogName={DialogList.CONFIRM_DELETE}
                />
            </>
        );
    }
};

export default React.memo(TownshipList);



// WEBPACK FOOTER //
// ./src/components/project/sections/tract/components/TownshipList.tsx